/* src/app/views/display/components/forms/menu-within-collection-added-to-display-form/menu-within-collection-added-to-display-form.component.scss */
:host lib-reactive-form-time,
:host lib-reactive-form-number {
  max-width: 18rem;
}
.scroll-speed-container {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
/*# sourceMappingURL=menu-within-collection-added-to-display-form.component.css.map */
